<template>
    <div class="asidebar">
        <div class="qxb-sidebar" v-show="showNav">
            <div class="py-2 flexcss">
                <img src="@/assets/images/sh_login_logo.png" alt="" class="cydn-logo">
                <div>
                    <el-tooltip class="item mr-1" effect="dark" content="搜索对话" placement="top-start"
                        v-show="showSearchIcon">
                        <span class="mt cur-pointer " @click="showSearch = true">
                            <i class="el-icon-search fl pt serch-icon"></i>
                        </span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="收起边栏" placement="top-start">
                        <span class="mt cur-pointer" @click="showNav = !showNav">
                            <svg t="1744277173231" class="icon" viewBox="0 0 1088 1024" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" p-id="7660" id="mx_n_1744277173232" width="28"
                                height="28">
                                <path
                                    d="M854.592 160c58.24 0 105.408 47.168 105.408 105.408v493.184c0 58.24-47.168 105.408-105.408 105.408H233.408C175.168 864 128 816.832 128 758.592V265.408c0-58.24 47.168-105.408 105.408-105.408h621.184z m-378.368 64H271.04C227.392 224 192 259.392 192 303.04v417.92c0 43.648 35.392 79.04 79.04 79.04h205.184v-576z m340.736 0H535.68v576h281.216c43.648 0 79.04-35.392 79.04-79.04v-417.92c0-43.648-35.392-79.04-79.04-79.04zM423.552 443.456v54.848h-158.08v-54.848h158.08z m0-146.304V352h-158.08v-54.848h158.08z"
                                    p-id="7661" fill="#8a8a8a"></path>
                            </svg>
                        </span>
                    </el-tooltip>
                </div>

            </div>
            <div class="sidebar-scroll" v-show="showSearchIcon">
                <div class="qxb-sidebar-item">
                    <div class="qxb-sidebar-history-title">
                        <span><svg t="1744342505985" class="fl history-icon-mt mr-1" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2931" width="16" height="16">
                                <path
                                    d="M512 25.6c268.6208 0 486.4 217.7792 486.4 486.4s-217.7792 486.4-486.4 486.4S25.6 780.6208 25.6 512 243.3792 25.6 512 25.6z m0 102.4C299.9296 128 128 299.9296 128 512c0 212.0704 171.9296 384 384 384 212.0704 0 384-171.9296 384-384 0-212.0704-171.9296-384-384-384z m-25.6 153.6a51.2 51.2 0 0 1 51.2 51.2v157.9776l138.5984 138.624a51.2 51.2 0 0 1 2.9952 69.1456l-2.9952 3.2512a51.2 51.2 0 0 1-72.3968 0l-153.6-153.6-2.432-2.6112a51.5072 51.5072 0 0 1-12.1344-26.88A51.1488 51.1488 0 0 1 435.2 512l0.0768 2.9952A51.5072 51.5072 0 0 1 435.2 512.768V332.8a51.2 51.2 0 0 1 51.2-51.2z"
                                    p-id="2932"></path>
                            </svg></span>
                        历史记录
                    </div>
                    <div class="qxb-sidebar-history-list">
                        <div v-for="(items, date) in historyList" :key="date">
                            <h5 class="qxb-sidebar-history-date">{{ date }}</h5>
                            <div class="qxb-sidebar-history-item flexcss" v-for="item in items" :key="item.id"
                                :class="id == item.id ? 'active' : ''">
                                <div class="qxb-sidebar-history-text" @click="goHistory(item)" :title="item.title">{{
                                    item.title }}</div>
                                <el-popover class="more-icon" placement="bottom-end" width="60" trigger="click">
                                    <div class="history-rename" @click="renameHistory(item)"><i
                                            class="el-icon-edit mr-1"></i>重命名</div>
                                    <div class="red-font history-del" @click="delHistory(item)"><i
                                            class="el-icon-delete mr-1"></i>删除</div>
                                    <div slot="reference"><i class="el-icon-more"></i></div>
                                </el-popover>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-2">
            <el-tooltip class="item " effect="dark" content="展开边栏" placement="right-start">
                <span class="mt cur-pointer rotate" v-show="!showNav" @click="showNav = !showNav">
                    <svg t="1744277173231" class="icon" viewBox="0 0 1088 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="7660" id="mx_n_1744277173232" width="28" height="28">
                        <path
                            d="M854.592 160c58.24 0 105.408 47.168 105.408 105.408v493.184c0 58.24-47.168 105.408-105.408 105.408H233.408C175.168 864 128 816.832 128 758.592V265.408c0-58.24 47.168-105.408 105.408-105.408h621.184z m-378.368 64H271.04C227.392 224 192 259.392 192 303.04v417.92c0 43.648 35.392 79.04 79.04 79.04h205.184v-576z m340.736 0H535.68v576h281.216c43.648 0 79.04-35.392 79.04-79.04v-417.92c0-43.648-35.392-79.04-79.04-79.04zM423.552 443.456v54.848h-158.08v-54.848h158.08z m0-146.304V352h-158.08v-54.848h158.08z"
                            p-id="7661" fill="#8a8a8a"></path>
                    </svg>
                </span>
            </el-tooltip>
        </div>
        <!-- 插槽部分 -->
        <slot class="qxb-main"></slot>
        <el-dialog title="" :visible.sync="showSearch" width="650px" top="20vh" @close="searchDialogClose">
            <el-input v-model="kw" placeholder="搜索对话" class="qxb-search-input" clearable
                @keyup.enter.native="getHistory">
                <el-button slot="append" icon="el-icon-search" @click="getHistory"></el-button>
            </el-input>
            <div class="qxb-sidebar-history-list qxb-sidebar-history-list-search">
                <div v-for="(items, date) in historyList" :key="date">
                    <h5 class="qxb-sidebar-history-date">{{ date }}</h5>
                    <div class="qxb-sidebar-history-text qxb-sidebar-history-item" v-for="item in items" :key="item.id"
                        @click="goHistory(item, 'search')">
                        {{ item.title }}
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>

</template>
<script>


export default {
    data() {
        return {
            userdata: {},
            showNav: true,
            showSearch: false,
            kw: '',
            historyList: [],
            id: 0,
            searchHistoryList: [],
            isEnterpriseFlag: false, //是否企业库的标志
        }
    },
    props: {
        showSearchIcon: {
            type: Boolean,
            default: true,
        },
        isAgent: { //是否智能体
            type: Boolean,
            default: false,
        },

    },

    mounted() {
        this.isEnterpriseFlag = this.$route.query.industryChat?true: false || this.$route.query.isEnterprise ? true : false; //从路由参数中获取是否企业库的标志
        // 添加事件监听
        // this.bus.$on('aiHistory-updated', this.getHistory);
        this.bus.$on('aiHistory-updated', () => {
            this.getHistory();
        });
        this.userdata = this.getuseriformation();
        this.getHistory();

    },
    beforeDestroy() {
        // 移除事件监听
        this.bus.$off('aiHistory-updated');
    },
    methods: {
        /**
         * @description:获取历史记录
         * @return: void
         */
        getHistory() {
            let ajaxUrl = '';
            if (!this.isAgent && !this.isEnterpriseFlag) {
                ajaxUrl = this.$api.cyl.deepseek.history() + '?page=1' + '&kw=' + this.kw;
            } else if (this.isEnterpriseFlag) {
               ajaxUrl = this.$api.cyl.assessment.history() + '?page=1' + '&kw=' + this.kw;
            }else{
                ajaxUrl =  this.$api.common.tencent.history() + '?page=1' + '&kw=' + this.kw;
            }
            this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(res => {
                if (res.data.success) {
                    if (this.kw != '') {
                        this.searchHistoryList = res.data.list;
                    } else {
                        let data = res.data.list;

                        // 获取当前日期
                        const now = new Date();

                        // 分组逻辑
                        const groupedData = data.reduce((acc, item) => {
                            const itemDate = !this.isEnterpriseFlag? new Date(item.date) : new Date(item.updateTime); // 将日期字符串转换为 Date 对象
                            const diffTime = now - itemDate; // 时间差（毫秒）
                            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); // 转换为天数

                            let groupKey = '';
                            if (diffDays === 0) {
                                groupKey = '今天';
                            } else if (diffDays === 1) {
                                groupKey = '昨天';
                            } else if (diffDays <= 7) {
                                groupKey = '一周内';
                            } else {
                                // groupKey = '更早';
                                // 如果是更早的数据，直接使用日期作为分组键
                                groupKey = !this.isEnterpriseFlag? item.date : item.updateTime; // 使用原始日期字符串
                            }

                            if (!acc[groupKey]) {
                                acc[groupKey] = [];
                            }
                            acc[groupKey].push(item);
                            return acc;
                        }, {});
                        console.log(groupedData);
                        this.historyList = groupedData;
                        this.searchHistoryList = this.historyList; //初始化搜索框的历史记录
                    }
                }
            }).catch(function (error) { });
        },

        /**
         * @description:点击对话记录，跳转到aiChat页面,type='history'时，代表是从搜索框中点击的记录
         * @param {Object} item 对话记录对象
         * @param {String} type history
         * @return: void
         */
        goHistory(item, type) {
            console.log(item,this.isEnterpriseFlag);
            // return;
            this.id = item.id;
            let jsonData = {
                title: item.title,
            };
            localStorage.setItem('aiChatData', JSON.stringify(jsonData));
            if (!this.isAgent && ! this.isEnterpriseFlag) {
                if (type == 'search') {
                    this.searchDialogClose();
                }
                this.routerself(`/aiChat?id=${item.id}&type=history`);
            }else if (this.isEnterpriseFlag){
                this.routerself(`/aiChat?id=${item.id}&type=history&isEnterprise=${this.isEnterpriseFlag}&title=${jsonData.title}`);
            }
            else{
                this.routerself(`/agentChat?id=${item.id}&type=history`);
            }
        },
        //重命名对话
        renameHistory(item) {
            this.$prompt('编辑对话名称', '重命名', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: item.title,
                // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                // inputErrorMessage: '邮箱格式不正确'
            }).then(({ value }) => {
                let ajaxUrl = '';
                if(!this.isAgent && !this.isEnterpriseFlag){
                    ajaxUrl = this.$api.cyl.deepseek.rename();
                }else if(this.isEnterpriseFlag){
                    ajaxUrl = this.$api.cyl.assessment.rename();
                    
                }
                else{
                    ajaxUrl = this.$api.common.tencent.rename();
                }
                let data = { id: item.id, title: value };
                // 发送请求
                $.ajax({
                    url: ajaxUrl,
                    method: 'POST',
                    data: data,
                    headers: { AuthToken: this.userdata.token },
                    success: (res) => {
                        console.log(res);
                        if (res.success) {
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.getHistory();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    },
                    error: function (xhr, status, error) {
                        console.error('Error:', error);
                    }
                });
            }).catch(() => {//取消
            });
        },
        //删除历史记录
        delHistory(item) {
            this.$confirm('是否删除该记录?', '确认删除', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                // type: 'error',
                roundButton: true,
                cancelButtonClass: 'cancelButtonClass',
                confirmButtonClass: 'confirmButtonClass',

            }).then(() => {
                let ajaxUrl = '';
                if(!this.isAgent && !this.isEnterpriseFlag){
                    ajaxUrl = this.$api.cyl.deepseek.delete();
                }else if( this.isEnterpriseFlag){
                    ajaxUrl = this.$api.cyl.assessment.delete();
                }else   {
                    ajaxUrl = this.$api.common.tencent.delete();
                }
                let data = { id: item.id };
                // 发送请求
                $.ajax({
                    url: ajaxUrl,
                    method: 'POST',
                    data: data,
                    headers: { AuthToken: this.userdata.token },
                    success: (res) => {
                        console.log(res);
                        if (res.success) {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.getHistory();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    },
                    error: function (xhr, status, error) {
                        console.error('Error:', error);
                    }
                });
            }).catch(() => {//取消
            });
        },

        /**
         * @description:关闭对话框搜索
         * @return: void
         * //关闭搜索弹框回调，需要关闭弹框并且清空搜索框,把搜索结果重置为历史记录
         */
        searchDialogClose() {
            this.showSearch = false;
            this.kw = '';
            this.searchHistoryList = this.historyList;
        }
    },


}
</script>
<style scoped lang="scss">
.asidebar {
    display: flex;
    flex-direction: row;
    flex: 1;

    .cydn-logo {
        width: 32px;
        height: 32px;
    }

    .serch-icon {
        color: #8a8a8a;
        font-weight: bolder;
        font-size: 20px;
    }
}

.rotate {
    transform: rotate(180deg);
}

.qxb-sidebar {
    width: 260px;
    background-color: #f3f3f3;
    padding: 10px;
    border-right: 1px solid #ddd;
    height: calc(100vh - 20px);
    position: relative;
    top: 0;
    left: 0;
    overflow: hidden;
}

.qxb-sidebar-item {
    margin-bottom: 10px;
}

.qxb-sidebar-history {
    margin-top: 10px;
}

.qxb-sidebar-history-title {
    font-weight: bold;
    margin-bottom: 5px;
}

.history-icon-mt {
    margin-top: 2px;
}

.qxb-sidebar-history-date {
    // font-weight: normal;
    font-size: 14px;
    color: #333;
    margin: 10px;
}

.qxb-sidebar-history-item {
    position: relative;
    --dsr-side-bg-rgb: 249, 251, 255;
    --dsr-local-active-bg-rgb: 219, 234, 254;
    --ds-rgb-blue-100: 235 235 235;
    --dsr-local-active-bg: rgb(var(--ds-rgb-blue-100));
    transition: all 0.3s;

    .more-icon {
        width: 64px;
        height: 100%;
        text-align: right;
        position: absolute;
        right: 0;
        top: 0;
        font-size: 16px;
        color: #333;
        // z-index: 100;
        background-image: linear-gradient(to right, rgba(var(--dsr-local-active-bg-rgb), 0), var(--dsr-local-active-bg) 50%);
        opacity: 0;

        i {
            display: inline-block;
            padding: 4px;
            color: #7a7a7a;
            font-size: 16px;
            cursor: pointer;
            border-radius: 5px;
            transform: translateY(25%);
            margin-right: 6px;

            &:hover {
                background-color: #f8f8f8;
                border-radius: 8px;
            }
        }


    }

    &:hover,
    &.active {
        background-color: #e0e0e0;
        border-radius: 8px;

        .more-icon {
            opacity: 1;
        }
    }
}

.qxb-sidebar-history-text {
    height: 38px;
    line-height: 38px;
    padding: 0 10px;
    // display: flex;
    cursor: pointer;
    font-size: 14px;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

}



.sidebar-scroll {
    max-height: 90%;
    overflow-y: auto;
}

.qxb-sidebar-history-list-search {
    max-height: 400px;
    overflow-y: auto;
}

.history-rename,
.history-del {
    cursor: pointer;
    font-size: 14px;
    line-height: 38px;
    padding: 0 10px;

    &:hover {
        background-color: #f8f8f8;
        border-radius: 5px;
    }
}

.cancelButtonClass {}
</style>
